import CoverModelCommon from 'common/models/cover';

export default class CoverModel extends CoverModelCommon {}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    cover: CoverModel;
  }
}
